<template>
  <div>
    <!--내부심사 체크리스트-->
    <c-table
      ref="table"
      title="LBL0010127"
      :columns="grid.columns"
      :data="targetDept.checklist"
      :gridHeight="gridHeight"
      :merge="grid.merge"
      :editable="editable && !disabled && checkAllFlag"
      :usePaging="false"
      :filtering="false"
      :columnSetting="false"
      @table-data-change="tableDataChange"
    >
      <template slot="table-chip">
        <q-chip
          v-for="(dept, idx) in options"
          outline square
          :key="idx"
          :removable="false"
          :color="dept.selected ? (dept.code == 'ALL' ? 'orange' : 'primary') : 'grey-6'"
          text-color="white"
          icon="memory"
          :selected.sync="dept.selected"
          :label="dept.codeName"
          v-model="dept.check"
          @update:selected="state => selectedDept(state, dept, idx)"
        >
          <q-tooltip v-if="dept.code != 'ALL'">심사자/부서</q-tooltip>
          <q-tooltip v-else>내부심사 체크리스트 결과</q-tooltip>
        </q-chip>
      </template>
      <template slot="prefixContent">
        <font color="#C10015">
          {{statusByDept}}
        </font>
      </template>
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <!--삭제-->
          <!-- <c-btn 
            v-if="editable&&!disabled" 
            label="LBLREMOVE" icon="remove" 
            @btnClicked="deleteChecklist" /> -->
          <!--추가-->
          <!-- <c-btn 
            v-if="editable&&!disabled" 
            label="LBLADD" icon="add" 
            @btnClicked="addChecklist" /> -->
          <!--저장-->
          <c-btn 
            v-if="editable && !disabled && checkAllFlag" 
            :isSubmit="isSave"
            :url="saveUrl"
            :param="targetDept.checklist"
            mappingType="PUT"
            label="LBLSAVE" 
            icon="save"
            @beforeAction="saveChecklist"
            @btnCallback="saveChecklistCallback" />
        </q-btn-group>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name==='customCol'">
          <component
            :is="imprComponent"
            :col="col"
            :props="props"
            :inputEditable="editable && !disabled && checkAllFlag"
            :isImmShow="true"
            :requestContentsCols="requestContentsCols"
            tableKey="saiInternalActionChecklistResultId"
            ibmTaskTypeCd="ITT0000150"
            ibmTaskUnderTypeCd="ITTU000155"
            @imprChange="imprChange"
          />
        </template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';

export default {
  name: 'internal-action-checklist',

  props: {
    popupParam: {
      type: Object,
      default: () => ({
        saiInternalActionTargetDeptId: '',
        isAuthData: false,
      }),
    },
    targetDept: {
      type: Object,
      default: () => ({
        saiInternalActionTargetDeptId: '',  // 내부심사 피심사팀 일련번호
        saiInternalActionId: '',  // 내부심사 수행계획서 일련번호
        deptCd: '',  // 피심사부서코드
        saiInternalActionTargetDeptStepCd: '',  // 내부심사 피심사팀 진행상태
        resultRemark: '',  // 결과요약
        regUserId: '',  // 등록자 ID
        chgUserId: '',  // 수정자 ID
        checklist: [], // 체크리스트 결과
        auditTeams: [], // 심사팀
      }),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    contentHeight: null,
  },
  data() {
    return {
      grid: {
        merge: [
          { index: 0, colName: 'targetDeptCd' },
          { index: 1, colName: 'saiInternalAuditClassCd' },
          { index: 2, colName: 'saiInternalAuditClassNameGubun' },
          { index: 3, colName: 'saiInternalAuditChecklistId' },
          { index: 4, colName: 'saiInternalAuditChecklistId' },
        ],
        columns: [
          {
            name: 'targetDeptName',
            field: 'targetDeptName',
            label: '피심사팀',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'saiInternalAuditClassName',
            field: 'saiInternalAuditClassName',
            label: 'ISO 구분',
            align: 'center',
            style: 'width:80px',
            sortable: false,
          },
          {
            name: 'systemElementsName',
            field: 'systemElementsName',
            label: '관련표준',
            align: 'left',
            style: 'width:100px',
            sortable: false,
          },
          // {
          //   name: 'sortOrder',
          //   field: 'sortOrder',
          //   //순서(순번)
          //   label: 'LBLSORTORDER',
          //   align: 'center',
          //   style: 'width:30px',
          //   sortable: false,
          // },
          {
            name: 'itemName',
            field: 'itemName',
            label: '심사항목',
            align: 'left',
            style: 'width:450px',
            sortable: false,
            type: 'html',
          },
          {
            name: 'aimMatter',
            field: 'aimMatter',
            label: '비고',
            align: 'left',
            style: 'width:200px',
            sortable: false,
            type: 'html',
          },
          {
            name: 'saiInternalAuditClassName2',
            field: 'saiInternalAuditClassName2',
            label: 'ISO 구분상세',
            align: 'center',
            style: 'width:80px',
            sortable: false,
          },
          {
            name: 'result',
            field: 'result',
            //내부심사결과
            label: 'LBL0010141',
            child: [
              {
                name: 'sar0000001',
                field: 'sar0000001',
                label: '적합',
                align: 'center',
                style: 'width:40px',
                sortable: false,
                type: 'check',
                checkIcon: 'task_alt',
                uncheckIcon: 'radio_button_unchecked',
                'true': 'Y',
                'false': 'N',
                color: 'green', 
              },
              {
                name: 'sar0000005',
                field: 'sar0000005',
                //부적합
                label: 'LBL0010143',
                align: 'center',
                style: 'width:40px',
                sortable: false,
                type: 'check',
                checkIcon: 'task_alt',
                uncheckIcon: 'radio_button_unchecked',
                'true': 'Y',
                'false': 'N',
                color: 'green', 
              },
              // {
              //   name: 'sar0000010',
              //   field: 'sar0000010',
              //   //관찰사항
              //   label: 'LBL0010144',
              //   align: 'center',
              //   style: 'width:40px',
              //   sortable: false,
              //   type: 'check',
              //   checkIcon: 'task_alt',
              //   uncheckIcon: 'radio_button_unchecked',
              //   'true': 'Y',
              //   'false': 'N',
              //   color: 'green', 
              // },
              // {
              //   name: 'sar0000015',
              //   field: 'sar0000015',
              //   //비적용
              //   label: 'LBL0010145',
              //   align: 'center',
              //   style: 'width:40px',
              //   sortable: false,
              //   type: 'check',
              //   checkIcon: 'task_alt',
              //   uncheckIcon: 'radio_button_unchecked',
              //   'true': 'Y',
              //   'false': 'N',
              //   color: 'green', 
              // },
            ]
          },
          {
            name: 'observation',
            field: 'observation',
            label: '관찰내용',
            align: 'left',
            style: 'width:250px',
            sortable: false,
            type: 'textarea',
          },
          {
            name: 'customCol',
            field: 'customCol',
            //개선번호/개선진행상태
            label: 'LBLIMPRNO_PROGRESS',
            align: 'center',
            style: 'width:150px',
            type: 'custom',
            sortable: false
          },
        ],
        data: [],
        height: '780px',
      },
      selectedDeptCd: '',
      selectedDeptName: '',
      check: false,
      editable: true,
      listUrl: '',
      listDeptUrl: '',
      saveUrl: '',
      deleteUrl: '',
      isSave: false,
      popupOptions: {
        isFull: false,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
      statusByDept: '',
      isSplitting: false,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    gridHeight() {
      return String(this.contentHeight - 130) + 'px';
    },
    targetDepts() {
      return this.targetDept.auditTeams
    },
    options() {
      let _options = [];
      _options.push({
        code: 'ALL',
        codeName: '심사팀장',
        selected: true,
      })
      // if (this.targetDepts !== undefined) {
      //   if (this.targetDepts && this.targetDepts.length > 0) {
      //     this.$_.forEach(this.targetDepts, item => {
      //       _options.push({
      //         code: item.teamDeptCd,
      //         codeName: item.userName,
      //         selected: false,
      //       })
      //     })
      //   }
      // }
      return _options;
    },
    checkAllFlag() {
      return this.selectedDeptCd == 'ALL';
    },
    // 개선요청 내용 전달
    requestContentsCols() {
      return ['systemElementsName'];
    },
    // 개선요청 Component
    imprComponent() {
      let components = () => import(`${'@/pages/common/ibm/tableImpr.vue'}`);
      return components;
    },
  },
  watch: {
    'targetDept.checklist': {
      immediate: true,
      handler(newList) {
        // splitInternalAuditClass가 매번 새 배열을 반환하므로, 그 결과를 $set하면 이 watcher가 다시 트리거된다.
        // isSplitting 가드로 그 재귀 트리거를 무시해서 무한루프를 막는다.
        if (this.isSplitting) return;
        if (!newList || newList.length === 0) return;
        this.isSplitting = true;
        this.splitInternalAuditClass(newList).then(list => {
          this.$set(this.targetDept, 'checklist', list)
        }).finally(() => {
          this.$nextTick(() => { this.isSplitting = false })
        })
      },
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sai.internal.action.checklistResult.list.url;
      this.saveUrl = transactionConfig.sai.internal.action.checklistResult.save.url;
      this.deleteUrl = transactionConfig.sai.internal.action.checklistResult.delete.url;
      this.listDeptUrl = selectConfig.sai.internal.action.checklistResult.depts.url;
      // code setting
      // list setting
      this.selectedDeptCd = 'ALL';
    },
    getChecklist() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        saiInternalActionTargetDeptId: this.targetDept.saiInternalActionTargetDeptId
      }
      this.$http.request((_result) => {
        // 분할(splitInternalAuditClass)은 targetDept.checklist watcher에서 단일 지점으로만 처리한다.
        // 여기서도 직접 분할하면 이 $set이 watcher를 다시 트리거해 이중 분할(레이스 컨디션)이 발생한다.
        this.$set(this.targetDept, 'checklist', _result.data)
        this.statusByDept = '';
      },);
    },
    getCheckDeptlist(_deptCd) {
      this.$http.url = this.listDeptUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        saiInternalActionTargetDeptId: this.targetDept.saiInternalActionTargetDeptId,
        saiInternalActionId: this.targetDept.saiInternalActionId,
        deptCd: this.targetDept.deptCd,
        teamDeptCd: _deptCd,
      }
      this.$http.request((_result) => {
        // 분할(splitInternalAuditClass)은 targetDept.checklist watcher에서 단일 지점으로만 처리한다.
        this.$set(this.targetDept, 'checklist', _result.data.list)
        this.statusByDept = _result.data.internalAuditResultStatusName;
      },);
    },
    /**
     * ISO 구분(saiInternalAuditClassCd)이 SAI_INTERNAL_AUDIT_CLASS_CD 콤보 중
     * attrVal1 = 'A' 인 항목의 code 와 같은 경우, 해당 콤보의 상세 구분(attrVal1 = 'B') 수만큼
     * 행으로 분할하여 'ISO 구분상세'별로 표시한다.
     */
    splitInternalAuditClass(list) {
      // eslint-disable-next-line no-console
      console.log('[splitInternalAuditClass] called. list=', list, 'length=', list ? list.length : null)
      if (!list || list.length === 0) {
        return Promise.resolve(list || []);
      }
      // 이미 상세 구분(class_cd2)이 배정된 행은 재분할 대상에서 제외한다.
      // (그렇지 않으면 재조회 시마다 이미 분할된 행이 다시 곱연산으로 분할되어 행이 기하급수적으로 늘어남)
      // MSSQL CHAR 컬럼 등으로 인해 코드값에 공백이 포함되어 내려올 수 있어 trim 후 비교한다.
      let trim = v => (v || '').toString().trim()
      let isUnsplit = item => !item.saiInternalAuditClassCd2 || trim(item.saiInternalAuditClassCd2) === trim(item.saiInternalAuditClassCd)
      // 상위(A) 구분 코드는 콤보에서 직접 선택되지 않도록 useFlag = 'N'으로 관리될 수 있으므로
      // useFlag 필터 없이 전체 코드를 조회하여 aItem/bItems를 찾는다.
      return this.$comm.getComboItems('SAI_INTERNAL_AUDIT_CLASS_CD', null, null).then((comboItems) => {
        let aItem = this.$_.find(comboItems, item => trim(item.attrVal1) === 'A');
        let bItems = aItem ? this.$_.filter(comboItems, item => trim(item.attrVal1) === 'B') : [];
        // TODO(디버그용, 확인 후 제거): 분할 조건 매칭 여부를 콘솔에서 확인하기 위한 임시 로그
        // eslint-disable-next-line no-console
        console.log('[splitInternalAuditClass] aItem=', aItem, 'bItems=', bItems)
        // eslint-disable-next-line no-console
        console.log('[splitInternalAuditClass] list sample=', this.$_.map(list, i => ({
          id: i.saiInternalActionChecklistResultId,
          cd: i.saiInternalAuditClassCd,
          cdLen: i.saiInternalAuditClassCd ? i.saiInternalAuditClassCd.length : null,
          name: i.saiInternalAuditClassName,
          cd2: i.saiInternalAuditClassCd2,
        })))

        let expanded = [];
        this.$_.forEach(list, item => {
          if (aItem && trim(item.saiInternalAuditClassCd) === trim(aItem.code)
            && isUnsplit(item)
            && bItems.length > 0) {
            this.$_.forEach(bItems, (bItem, idx) => {
              expanded.push({
                ...item,
                // 원본 행의 식별자는 첫 상세 행에만 유지하고(UPDATE 대상), 나머지 분할 행은 신규 식별자를 부여(INSERT 대상)
                saiInternalActionChecklistResultId: idx === 0 ? item.saiInternalActionChecklistResultId : uid(),
                // 신규로 생성되는 분할 행은 DB에 없는 id이므로 editFlag='C'를 명시해야 저장 시 INSERT 경로를 탄다.
                // (그대로 두면 체크박스 클릭 시 CTable이 editFlag='U'로 세팅해 존재하지 않는 id로 UPDATE를 시도, 0건 반영되어 저장되지 않는다.)
                // idx===0도 saiInternalAuditClassCd2가 프로그램적으로 새로 배정된 것이므로, 사용자가 그 행을 직접
                // 클릭하지 않아도 저장되도록 editFlag를 최소 'U'로 강제한다. 그렇지 않으면 cd2가 DB에 반영되지 않아
                // 다음 조회 때 이 행이 "아직 분할 안 된 원본"으로 다시 인식되어 또 분할되는 중복이 발생한다.
                editFlag: idx === 0 ? (item.editFlag === 'C' ? 'C' : 'U') : 'C',
                regUserId: idx === 0 ? item.regUserId : this.$store.getters.user.userId,
                // idx===0이 editFlag='U'로 강제되는 경우, 수정자 정보도 함께 전달한다.
                chgUserId: idx === 0 ? this.$store.getters.user.userId : item.chgUserId,
                saiInternalAuditClassCd2: bItem.code,
                saiInternalAuditClassName2: bItem.codeName,
              })
            })
          } else if (isUnsplit(item)) {
            // "안전보건&환경" 분할 대상이 아닌 단독 항목(예: "안전보건" 단독)도, cd2가 처음 배정되는 것이므로
            // 사용자가 직접 건드리지 않아도 저장되도록 editFlag를 최소 'U'로 강제한다.
            expanded.push({
              ...item,
              editFlag: item.editFlag === 'C' ? 'C' : 'U',
              chgUserId: this.$store.getters.user.userId,
              saiInternalAuditClassCd2: item.saiInternalAuditClassCd,
              saiInternalAuditClassName2: item.saiInternalAuditClassName,
            })
          } else {
            expanded.push(item)
          }
        })
        return expanded;
      })
    },
    tableDataChange(props, col) {
      // let blackList = ['itemName', 'aimMatter', 'observation']
      let whiteList = ['sar0000001', 'sar0000005', 'sar0000010', 'sar0000015']
      if (whiteList.indexOf(col.name) > -1 && props.row[col.name] === 'Y') {
        this.$_.forEach(whiteList, item => {
          if (item === col.name) return
          this.$set(props.row, item, 'N')
        })
      }
    },
    /* eslint-disable no-unused-vars */
    deleteChecklist() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSG0010007', // 삭제할 행을 지정하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: 'LBLCONFIRM',  //확인
          message: 'MSGREMOVE', // 삭제하시겠습니까?,
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            let _deleteData = this.$_.filter(selectData, (item) => {
              return item.editFlag !== 'C'
            })

            this.$http.url = this.deleteUrl;
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(_deleteData),
            };
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              
              this.$_.forEach(selectData, item => {
                this.targetDept.checklist = this.$_.reject(this.targetDept.checklist, item);
              })
              this.$refs['table'].$refs['compo-table'].clearSelection();
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    addChecklist() {
      this.popupOptions.title = 'LBL0010150'; // 체크리스트
      this.popupOptions.param = {
        type: 'multiple'
      };
      this.popupOptions.target = () => import(`${'@/pages/sai/internalAudit/base/internalChecklistPop.vue'}`);
      this.popupOptions.width = '80%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeChecklistPopup;
    },
    closeChecklistPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        let _data = [];
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.targetDept.checklist, { saiInternalAuditChecklistId: item.saiInternalAuditChecklistId }) === -1) {
            _data.push({
              saiInternalActionChecklistResultId: uid(),  // 내부심사 수행계획서 체크리스트 일련번호
              saiInternalActionTargetDeptId: this.targetDept.saiInternalActionTargetDeptId,  // 내부심사 피심사팀 일련번호
              saiInternalAuditChecklistId: item.saiInternalAuditChecklistId,  // 내부감사 체크리스트 항목 일련번호
              saiInternalAuditClassCd: item.saiInternalAuditClassCd,
              saiInternalAuditClassCd2: item.saiInternalAuditClassCd2,
              saiInternalAuditClassName: item.saiInternalAuditClassName,
              saiInternalAuditClassName2: item.saiInternalAuditClassName2,
              saiInternalAuditClassNameGubun: item.saiInternalAuditClassName + '/' + item.systemElementsName,
              systemElementsName: item.systemElementsName,  // 시스템 요소
              itemName: item.itemName,  // 내부심사 항목
              aimMatter: item.aimMatter,  // 내부심사 시 착안 사항
              saiInternalAuditResultCd: 'SAR0000001',  // 내부심사 결과
              observation: '',  // 관찰사항
              sortOrder: item.sortOrder,  // 순번
              sar0000001: 'Y',
              sar0000005: 'N',
              sar0000010: 'N',
              sar0000015: 'N',
              editFlag: 'C',
              regUserId: this.$store.getters.user.userId,
            })
          }
        })
        this.targetDept.checklist = this.$_.concat(_data, this.targetDept.checklist)
      }
    },
    saveChecklist() {
      if (this.$comm.validTable(this.grid.columns, this.targetDept.checklist)) {
        window.getApp.$emit('CONFIRM', {
          title: 'LBLCONFIRM',  // 확인
          message: 'MSGSAVE', // 저장하시겠습니까?   // 저장하시겠습니까?
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            let resultList = ['sar0000001', 'sar0000005', 'sar0000010', 'sar0000015']
            this.$_.forEach(this.targetDept.checklist, check => {
              this.$_.forEach(resultList, item => {
                if (check[item] === 'Y') {
                  check.saiInternalAuditResultCd = this.$_.toUpper(item);
                  return false;
                }
              })
            })
            // eslint-disable-next-line no-console
            console.log('[saveChecklist] about to save. rows=', this.$_.map(this.targetDept.checklist, r => ({
              id: r.saiInternalActionChecklistResultId,
              idLen: r.saiInternalActionChecklistResultId ? r.saiInternalActionChecklistResultId.length : null,
              editFlag: r.editFlag,
              cd: r.saiInternalAuditClassCd,
              cd2: r.saiInternalAuditClassCd2,
            })))
            this.isSave = !this.isSave
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    saveChecklistCallback(_result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getChecklist();
      this.$emit('stepup')
    },
    // 개선창 닫기 후
    imprChange() {
      this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
    },
    selectedDept(state, dept, idx) {
      this.selectedDeptCd = dept.code;
      this.selectedDeptName = dept.codeName;
      if (state) {
        this.options.forEach((item, index) => {
          if (idx !== index) {
            this.$set(item, 'selected', false)
          } else {
            this.$set(item, 'selected', true)
          }
        })
      } else {
        this.$set(this.options[idx], 'selected', true)
      }
      if (dept.code == 'ALL') {
        this.getChecklist();
      } else {
        this.getCheckDeptlist(dept.code)
      }
    },
  }
};
</script>